import React from 'react';
import StyledLabel from 'styles/basic/Label';
import Flex from './Flex';
import IF from 'mrf/view/IF';
import T from 'mrf/utils/T';

const Label = ({ actions, required, readOnly, disableTranslation, children }) => {
    return <Flex gap={1}>
        <StyledLabel>
            {disableTranslation ? children: <T>{children}</T>}
            <IF condition={!readOnly && !!required}>*</IF>
        </StyledLabel>
        <IF condition={!!actions}><div className='-mt-0.5'>{actions}</div></IF>
    </Flex>
}

export default Label;
